module.exports = __webpack_public_path__ + "static/media/SOLDEMEXICO_8abril.179dda1a.jpg";